export default __webpack_public_path__ + "static/BgMobileWedo-419a3a8fd084ed468b5192fada54253b.png";